<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;" *ngIf="statusCounts$ | async as counts">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-livraison/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <span *ngIf="currentStatus === 'tous'">({{ counts['Tous'] ?? 0 }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-livraison/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <span *ngIf="currentStatus === 'brouillon'">({{ counts['Brouillon'] ?? 0 }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-livraison/cree']" [class.active]="currentStatus === 'cree'" (click)="filterByStatus('cree')">
                    Créé <span *ngIf="currentStatus === 'cree'">({{ counts['Crée'] ?? 0 }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-livraison/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <span *ngIf="currentStatus === 'annule'">({{ counts['Annulé'] ?? 0 }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-livraison/livre']" [class.active]="currentStatus === 'livre'" (click)="filterByStatus('livre')">
                    Livré <span *ngIf="currentStatus === 'livre'">({{ counts['Livré'] ?? 0 }})</span>
                </a>
            </li>
        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>

